import styled from "styled-components";

import { layout } from "/styles";

export const NegativeResultsWrapper = styled.div(
  layout.flexVertical,
  layout.margin("standard", "skip", "skip", "skip"),
);
